import { inject, Injectable } from '@angular/core';
import { sqaContent } from '@com-delta-idp/mnx-login-ui';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { BehaviorSubject } from 'rxjs';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { LoginModalContent } from '../../models/aem';
import { StoredQuestionsResponse } from '../../models/recover-by-sqa.interface';
import { NextDisplayViewService } from '../../services';
import { RecoverSqaContentService } from '../../services/recover-sqa-service/recover-sqa-content.service';
import { RecoverSqaHelperService } from '../../services/recover-sqa-service/recover-sqa-helper.service';
import { WifiPortalService } from '../../services/wifi-portal/wifi-portal.service';
import { RecoverYourAccountFacadeService } from '../recover-your-account-facade/recover-your-account-facade.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverSqaFacadeSupportService {
  pageContent$ = new BehaviorSubject<sqaContent | undefined>(undefined);
  sqaError$ = new BehaviorSubject<string>('');
  aemContent!: LoginModalContent;
  secretQuestions!: StoredQuestionsResponse;
  protected analytics = inject(AnalyticsService);
  protected wifiPortalService = inject(WifiPortalService);
  protected loginHelperUtils = inject(LoginHelperUtils);
  protected nextDisplayViewService = inject(NextDisplayViewService);
  protected helper = inject(RecoverSqaHelperService);
  protected sqacontentService = inject(RecoverSqaContentService);
  protected recoverYourAccountFacadeService = inject(
    RecoverYourAccountFacadeService
  );
}
